<p-dialog
    [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
    [style]="{ width: '50rem' }"
    [(visible)]="visible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="true"
    (onHide)="fechar()"
>
    <ng-template pTemplate="header">
        <div class="flex justify-content-start">
            <span class="text-900 text-xl font-bold">
                <i class="pi pi-id-card mr-1"></i>
                Clientes
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="content">
        <p-messages
            [(value)]="messagesDialog"
            [enableService]="false"
            [closable]="true"
        ></p-messages>
        <button
            *ngIf="view === 'LISTAGEM'"
            pButton
            pRipple
            label="Novo"
            (click)="cadastroCliente()"
            icon="pi pi-plus"
            class="field p-button-outlined"
        ></button>

        <form #formCliente="ngForm" name="formCliente" *ngIf="view === 'CADASTRO'">
            <div class="formgroup">
                <div class="p-fluid p-formgrid grid">
                    <div class="field col-12 md:col-8">
                        <label htmlFor="nome">Nome</label>
                        <input
                            oninput="this.value = this.value.toUpperCase();"
                            type="text"
                            pInputText
                            placeholder="Digite o nome e sobrenome"
                            name="nome"
                            ngModel
                            #nome="ngModel"
                        />
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="apelido">Apelido</label>
                        <input
                            oninput="this.value = this.value.toUpperCase();"
                            type="text"
                            pInputText
                            placeholder="Digite o apelido"
                            name="apelido"
                            ngModel
                            #apelido="ngModel"
                        />
                    </div>
                    <div class="field col-12 md:col-3">
                        <label htmlFor="cpf">CPF</label>
                        <p-inputMask
                            mask="999.999.999-99"
                            [unmask]="true"
                            type="text"
                            placeholder="000.000.000-00"
                            name="cpf"
                            ngModel
                            #cpf="ngModel"
                        ></p-inputMask>
                    </div>
                    <div class="field col-12 md:col-2">
                        <label htmlFor="aniversario">Aniversário</label>
                        <p-inputMask
                            mask="99/99"
                            type="text"
                            placeholder="DD/MM"
                            name="aniversario"
                            ngModel
                            #aniversario="ngModel"
                        ></p-inputMask>
                    </div>
                    <div class="field col-12 md:col-4">
                        <label htmlFor="email">E-mail</label>
                        <input
                            pInputText
                            type="email"
                            placeholder="seuemail@mail.com"
                            name="email"
                            ngModel
                            email="true"
                            #email="ngModel"
                        />
                        <div *ngIf="email.hasError('email')" class="alerta">
                            <small>Digite um e-mail válido</small>
                        </div>
                    </div>

                    <div class="field col-12 md:col-3">
                        <label htmlFor="telefone">Telefone</label>
                        <p-inputMask
                            mask="(99) 99999-9999"
                            [unmask]="true"
                            type="text"
                            placeholder="(99) 99999-9999"
                            name="telefone"
                            ngModel
                            #telefone="ngModel"
                            [required]="true"
                        ></p-inputMask>
                    </div>
                </div>

                <div class="p-fluid p-formgrid grid justify-content-between">
                    <div class="col-12 md:col-3">
                        <button
                            *ngIf="!loadingCadastroCliente; else exibirBotaoFalsoCadastroCliente"
                            type="button"
                            pButton
                            icon="pi pi-check"
                            label="Cadastrar"
                            class="p-button-outlined p-button-success"
                            (click)="cadastrarCliente(formCliente.form)"
                        ></button>
                        <ng-template #exibirBotaoFalsoCadastroCliente>
                            <button
                                type="button"
                                pButton
                                icon="pi pi-spin pi-spinner"
                                label="Cadastrar"
                                class="p-button-success mt-5"
                                [disabled]="true"
                            ></button>
                        </ng-template>
                    </div>
                    <div class="col-12 md:col-3">
                        <button
                            type="button"
                            pButton
                            icon="pi pi-times"
                            label="Cancelar"
                            class="p-button-outlined"
                            (click)="view = 'LISTAGEM'"
                        ></button>
                    </div>
                </div>
            </div>
        </form>

        <p-table
            *ngIf="view === 'LISTAGEM'"
            #tbClientes
            [value]="clientes"
            dataKey="id"
            [lazy]="true"
            [paginator]="true"
            [rows]="5"
            [totalRecords]="totalRegistros"
            (onLazyLoad)="onLazyLoad($event)"
            [loading]="loading"
            sortMode="single"
            [rowHover]="true"
            [showCurrentPageReport]="true"
            responsiveLayout="scroll"
            styleClass=" p-datatable-sm"
            currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
        >
            <ng-template pTemplate="caption">
                <div class="flex justify-content-end flex-column sm:flex-row">
                    <div>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input
                                pInputText
                                type="text"
                                #filter
                                (input)="buscar($event)"
                                placeholder="Buscar"
                                class="w-full"
                            />
                        </span>
                        <span class="ml-2">
                            <button
                                pButton
                                class="p-button-outlined"
                                icon="pi pi-filter-slash"
                                pTooltip="Limpar Filtros"
                                (click)="limpar()"
                            ></button>
                        </span>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="nome">
                        Nome
                        <p-sortIcon field="nome"></p-sortIcon>
                    </th>
                    <th pSortableColumn="apelido">
                        Apelido
                        <p-sortIcon field="apelido"></p-sortIcon>
                    </th>
                    <th pSortableColumn="cpf">
                        CPF
                        <p-sortIcon field="cpf"></p-sortIcon>
                    </th>
                    <th style="text-align: center">Ações</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr>
                    <td>
                        {{ item.nome }}
                    </td>
                    <td>
                        {{ item.apelido }}
                    </td>
                    <td>
                        {{ item.cpf ? (item.cpf | cpfPipe) : "NÃO CADASTRADO" }}
                    </td>
                    <td style="text-align: center">
                        <button
                            pButton
                            pRipple
                            type="button"
                            pTooltip="Detalhar"
                            icon="pi pi-eye"
                            class="p-button-info mr-2"
                            style="box-shadow: none"
                            (click)="abrirJanelaDetalhe(item.id)"
                        ></button>
                        <button
                            pButton
                            pRipple
                            pTooltip="Selecionar"
                            (click)="selecionarCliente(item)"
                            icon="pi pi-check"
                            class="p-button-success"
                        ></button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7">Nenhum registro encontrado.</td>
                </tr>
            </ng-template>
            <ng-template pTemplate="loadingbody">
                <tr>
                    <td colspan="7">Carregando clientes. Por favor aguarde.</td>
                </tr>
            </ng-template>
        </p-table>
    </ng-template>
</p-dialog>
